import autoComplete from "@tarekraafat/autocomplete.js";

export default class AutoComplete {
  constructor(data, options) {
    this.data = data;
    this.options = {
      selector: options.selector,
    };

    this.init();
  }

  init() {
    const ac = new autoComplete({
      data: {
        src: this.data,
        keys: ["slug"],
      },
      trigger: (query) => {
        return true;
      },
      events: {
        input: {
          selection: (event) => {
            event.preventDefault();
            const selection = event.detail.selection.value;

            const hiddenInput = document.querySelector(event.srcElement.dataset.target);

            if (hiddenInput) {
              hiddenInput.value = selection.slug;
            }

            ac.input.value = selection.name;
            ac.input.blur();
          },
          focus(event) {
            ac.start("");
          },
          keydown(event) {
            // Check pressed key
            switch (event.keyCode) {
              // Down/Up arrow
              case 40:
              case 38:
                event.preventDefault();
                // Move cursor based on pressed key
                event.keyCode === 40 ? ac.next() : ac.previous();
                break;
              // Enter
              case 13:
                // If cursor moved
                if (ac.cursor >= 0) ac.select(event);
                if (ac.isOpen) {
                  ac.select(ac.next());
                }
                break;
            }
          },
        },
      },
      resultsList: {
        maxResults: 100,
        class: "autoComplete_results",
      },
      resultItem: {
        element: (item, data) => {
          const {
            value: { name, slug },
          } = data;
          item.classList.add("autoComplete_result");
          item.innerHTML = `<span class='name'>${name}</span>`;
        },
      },
      threshold: 0,
      placeHolder: this.options.selector.placeHolder,
      selector: this.options.selector,
      debounce: 300,
      diacritics: true,
    });
  }
}
